import React from 'react';
import { storeAppDispatch } from '../../../../GlobalState/Store';
import { setChainLogin } from '../../../../reducers/UserReducer';
import { isMainnet } from '../../../../constants/envs';

const IS_SKALE_LIVE = isMainnet ? false : true;


export const EthNetworkChoice = () => {

  const ethChainChoiceHandler = (chain = '') => {
    sessionStorage.removeItem('exclusiveLogin');
    storeAppDispatch(setChainLogin({ chainLogin: chain }));
  };

  const handleBack = () => {
    storeAppDispatch(setChainLogin({ chainLogin: '' }));
  };

  return (
    <div id="eth-network-choice-wrapper" className="row">
      <div className="col-12">
        <p id="eth-choice-back" onClick={handleBack}>Back &gt;</p>
      </div>
      <div className="col-1"></div>
      <div className="col-4">
        <p style={{ fontSize: '18px', fontFamily: 'Verdena' }}>Ethereum {isMainnet ? 'Mainnet' : 'Testnet'}</p>
        <button
          className="btn btn-warning"
          onClick={() => ethChainChoiceHandler('eth')}
          style={{ color: 'black', fontSize: '22px' }}
        >
          <span>Ethereum</span>
        </button>
      </div>
      <div className="col-5">
        <p style={{ fontSize: '18px', fontFamily: 'Verdena' }}>Ethereum Layer-2's</p>
        <button
          className="btn btn-warning"
          onClick={() => ethChainChoiceHandler('imx')}
          style={{ fontSize: '22px', display: 'inline-block' }}
        >
          <span>Immutable</span>
        </button>
        <button
          className="btn btn-warning"
          onClick={() => ethChainChoiceHandler('skl')}
          style={{ fontSize: '22px', display: 'inline-block', marginLeft: '5px' }}
          disabled={!IS_SKALE_LIVE}
        >
          {!IS_SKALE_LIVE ? '?' : 'Skale'}
        </button>
      </div>
    </div>
  );
};
